import { Button } from "@mui/material";
import { ElementDetailsAction } from "models/Resources/ElementDetailsResource";
import { useState } from "react";
import ActionParams from "./ActionParams";
import ConfirmAction from "./ConfirmAction";
import "./DetailsAction.scss";

export type DetailsActionProps = {
  elementAction: ElementDetailsAction;
  onActionClick: (actionType: string, values?: any) => void;
};

const DetailsAction: React.FC<DetailsActionProps> = ({
  elementAction,
  onActionClick,
}) => {
  const isActionAuthorized = elementAction.autorise;
  const isActionAvailable = elementAction.disponible;
  const [isButtonActive] = useState(isActionAuthorized && isActionAvailable);
  const [currentStep, setCurrentStep] = useState("BUTTON");
  const isParams = elementAction.parametres !== undefined && elementAction.parametres.length > 0;
  const [params, setParams] = useState({});

  const handleNext = () => {
    if (currentStep === "BUTTON") {
      if (isParams) {
        setCurrentStep("PARAMS");
      } else {
        setCurrentStep("CONFIRM");
      }
    } else if (currentStep === "PARAMS") {
      setCurrentStep("CONFIRM");
    } else if (currentStep === "CONFIRM") {
      onActionClick(elementAction.id, params);
    }
  };
  function handleActionParams(isConfirmed: boolean, values?: any): void {
    if (isConfirmed) {
      if (currentStep === "PARAMS") setParams(values);
      handleNext();
    } else {
      setCurrentStep("BUTTON");
    }
  }
  
  function handleActionConfirmed(isConfirmed: boolean): void {
    if (isConfirmed) {
      handleNext();
    } else {
      setCurrentStep("BUTTON");
    }
  }
    return (
      <>
        <Button
          type="button"
          variant="outlined"
          size="small"
          sx={{
              backgroundColor: '#ffffff',
              minWidth: '19em',
              ':hover': {
                    bgcolor: 'primary.main', // theme.palette.primary.main
                    color: 'white',
                  },            
            }}
          disabled={!isButtonActive}
          onClick={handleNext}>
          {elementAction.etiquette}
        </Button>
          { currentStep === "CONFIRM" ? <ConfirmAction
            elementAction={elementAction}
            onActionConfirm={handleActionConfirmed}
            isOpen={true}
          /> : null}
          { currentStep === "PARAMS" ? 
             <ActionParams
             elementAction={elementAction}
             onActionConfirm={handleActionParams}
             ></ActionParams> : null}
      </>
    );

};
export default DetailsAction;
